<!--意见反馈列表-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form class="flex-form " layout="inline" :form="form" :colon="false">
          <div class="flex gap-5">
            <div style="width:400px">
              <a-form-item label="内容">
                <a-input v-decorator="['content']"></a-input>
              </a-form-item>
            </div>
            <a-form-item label="状态">
              <a-select
                class="form-control"
                :options="typesMap.status"
                v-decorator="['status']"
                placeholder="请选择"
              ></a-select>
            </a-form-item>
          </div>
        </a-form>

        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">反馈列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="addRow">
          <app-icon type="icon-tianjia"></app-icon>
          添加反馈
        </a-button>
      </div>
      <div class="queryView-main">
        <!-- :scroll="{ x: 1400 }" -->
        <a-table
          class="mt-5"
          :rowKey="useRowIndex"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '类型',
        width: '10%',
        align: 'center',
        dataIndex: 'typeName',
      },
      {
        title: '反馈内容',
        width: '30%',
        align: 'center',
        dataIndex: 'content',
      },
      {
        title: '图片',
        width: '10%',
        align: 'center',
        dataIndex: 'pictureUrl',
        customRender: (text, row) => {
          return <auto-img style="width:100px;height:100px" src={text}></auto-img>
        },
      },
      {
        title: '状态',
        width: '10%',
        align: 'center',
        dataIndex: 'status',
        customRender: (text, row) => {
          return <span>{this.translateType$t(text, 'status')}</span>
        },
      },
      {
        title: '备注',
        width: '10%',
        align: 'center',
        dataIndex: 'remark',
      },
      {
        title: '反馈时间',
        width: '10%',
        align: 'center',
        dataIndex: 'feedbackTime',
      },
      {
        title: '操作',
        width: '10%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex gap-5 justify-center text-primary-500">
              <app-icon
                type="icon-chakan"
                class="cursor-pointer"
                onClick={() => {
                  this.checkRow(row)
                }}
                title="查看"
              ></app-icon>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        status: [
          { value: 1, label: '未受理' },
          { value: 2, label: '已受理' },
        ],
      }
    },
  },
  methods: {
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/user/admin/feedback', {
          params: {
            page: _pageNumber,
            limit: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    checkRow(row) {
      this.$router.push({
        path: '/m/scopeMain/feedback/addNewQuestion',
        query: {
          feedbackId: row.feedbackId,
        },
      })
    },
    addRow() {
      this.$router.push({
        path: '/m/scopeMain/feedback/addNewQuestion',
      })
    },
  },
  mounted() {
    this.doQuery()
  },
}
</script>

<style lang="less" scoped></style>
